/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'

import { ImgSanity } from '@slite/components'

import { WebsiteCard } from '../../components/Card/Card'
import { useRoutes } from '../../routes'
import { SMALL_BREAKPOINT } from '../../utils/breakpoints'

type SliteTemplateCardProps = {
  slug: string
  imageUrl: string
  imageAlt: string
  color: string
  description: string
  title: string
  key: string
}

export const SliteTemplateCard = ({
  slug,
  imageUrl,
  imageAlt,
  title,
  description,
  key,
  color,
}: SliteTemplateCardProps) => {
  const routes = useRoutes()
  return (
    <WebsiteCard
      key={key}
      hoverOutline={false}
      className="grid-span-4 grid-span-6-medium grid-span-12-small grid-offset-0-small flexbox flexbox-column padding-bottom-20 padding-8 border-small border-alpha-shade-40 border-shade-05-on-hover"
      href={routes.templates.detail({ slug })}
      css={css`
        @media (min-width: ${SMALL_BREAKPOINT}px) {
          max-height: 300px;
        }
      `}
    >
      <div
        className={classNames(
          `background-${color} flexbox flexbox-centered radius-larger margin-bottom-20`
        )}
        css={css`
          aspect-ratio: 4/2;
        `}
      >
        <ImgSanity
          src={imageUrl}
          alt={imageAlt}
          style={{ maxWidth: 100, maxHeight: 100 }}
        />
      </div>
      <div className="padding-horizontal-20">
        <h5 className="font-weight-semibold font-size-5 margin-bottom-2 shade-05">
          {title}
        </h5>
        <p
          className="shade-20 font-size-6"
          css={css`
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
          `}
        >
          {description}
        </p>
      </div>
    </WebsiteCard>
  )
}
